// extracted by mini-css-extract-plugin
module.exports = {"homepage":"page-styles_homepage__f3fol"};